<!--
 * @Author: Belief liang.huang@rockynet.onaliyun.com
 * @Date: 2025-11-04 16:55:53
 * @LastEditors: hl
 * @LastEditTime: 2026-03-26 15:00:00
 * @FilePath: /mall-wap-vue/src/views/mine/question/detail/components/Overseas.vue
-->
<template>
  <div class="question">
    <template v-if="$appSource === 3">
      <div class="item">
        {{ $G("Milky Cloud承诺其销售的所有商品是")
        }}<span class="item_blod">"澳洲正品保障，本地直供"</span
        >，为您创造一个便捷的澳洲本地购物体验，足不出户轻松购遍全澳，让您省心更放心！
      </div>
      <div class="item">
        {{
          $G(
            "Milky Cloud已与多家澳洲本地及全球一线品牌、行业巨头达成战略合作关系，商品范围覆盖澳大利亚及全球多个国家和地区，SKU丰富，品牌商授权直供，全程技术保障，从源头为消费者提供高品质的服务。"
          )
        }}
      </div>
      <div class="item">
        {{ $G("Milky Cloud销售的商品均为优质正品，消费者下单后，")
        }}<span class="item_blod"
          >商品从澳洲本地仓库或品牌授权合作仓直接发出，符合澳大利亚海关及相关法规要求，物流全程可追踪，提供从发货地到消费者目的地的完整物流状态信息。</span
        >
      </div>
    </template>
    <template v-else>
      <div class="item">
        {{ $G("az全球购承诺其销售的所有商品是")
        }}<span class="item_blod">“海外正品保障，海外直供”</span
        >，为您创造一个便捷的跨境购物体验，足不出户轻松扫遍澳新，让您省心更放心！
      </div>
      <div class="item">
        {{
          $G(
            "妙客云已与多家全球一线品牌及行业巨头达成战略合作关系，同时将会有更多知名平台入驻妙客云，业务涉及澳新乃至全球多个国家和地区，SKU丰富，品牌商授权直供，全程技术保障，从源头为消费者提供高品质的服务。"
          )
        }}
      </div>
      <div class="item">
        {{ $G("az全球购销售的海外商品均为优质海外商品，消费者下单后，")
        }}<span class="item_blod"
          >商品从全球甄选产地通过国际物流方式发出或从符合国家法律规定的中国保税区发出，且有物流公司提供的从商家发货地到消费者目的地之间完整物流状态信息。</span
        >
      </div>
    </template>
  </div>
</template>

<script>
export default {
  methods: {
    backClick() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.question {
  background: #fff;
  font-size: 14px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 22px;
  padding: 15px;
  border-top: 1px solid #eee;
}
.item {
  padding-top: 10px;
  text-indent: 25px;
}
.item_blod {
  font-weight: 500;
}
</style>
